<script>
import VueTypes from 'vue-types'
import store from '../Store/store'
import QuestionTitle from './QuestionTitle.vue'
import QuestionAnswer from './QuestionAnswer.vue'

export default {
  name: 'Question',

  components: {
    QuestionTitle,
    QuestionAnswer
  },

  props: {
    index: VueTypes.string.def('')
  },

  computed: {
    isActive() {
      return store.getters['questions/isActiveQuestionIndex'](this.$attrs.questionindex)
    }
  },

  methods: {
    isActiveIndex(index) {
      return this.$attrs.activeindex === index
    }
  }
}
</script>

<style lang="scss" scoped>
.question {
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(177, 177, 177);

  + .question {
    margin-top: 10px;
  }
}
</style>
